import { Categorias, SiyNo, TiposEstados } from "@cf-v5-workspace/enums";

export default class CRMEstadoModel {
    id: number;
    descripcion: string;
    categoria: Categorias;
    tipo: TiposEstados;
    color: string;
    explicacion: string;
    tomarTiempos: SiyNo;
    activarDiasAlistamiento: SiyNo;
    permitirModificar: SiyNo;
    codigoTipoDocumento: string;
    firmaDigitalSMS: boolean;
    firmaDigitalCorreo: boolean;
    firmaDigitalCodigoAleatorioCorreo: boolean;
    firmaDigitalCodigoAleatorioSMS: boolean;
    firmaDigitalIdEstadoSiguiente: number;
    documentoSoporte: boolean;
    enviarDocumentoSoporte: boolean;
    idPlantilla: number;
    afectaDisponibilidadCEDI: SiyNo;
    documentoDevolucion: string;
    devolucionVenta: SiyNo;
    textoFirmaDigitalPlantilla: string;
}